import { getAccountPasswordUrl } from 'account';
import { Context as AuthorizationContext } from 'authorization/Context';
import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PrivateLayoutContext } from 'styleguide/layout/Private/Context';
import { isExternalUser } from 'user';
import {
  CHANGE_PASSWORD,
  DAY,
  DAYS,
  PASSWORD_EXPIRY_NOTIFICATION_TEXT,
  SUBMIT_LABEL,
} from './constants';

export type Props = {};

const PasswordExpiryNotification: React.FC<Props> = () => {
  const { user } = useContext(AuthorizationContext);
  const { dispatch } = useContext(PrivateLayoutContext);
  const navigate = useNavigate();

  useEffect(() => {
    const passwordExpiresConfigValue = user?.passwordExpiresConfigValue;
    const passwordChangedSinceInDays = user?.passwordChangedSinceInDays;
    const passwordValidDays =
      passwordExpiresConfigValue &&
      passwordChangedSinceInDays &&
      passwordExpiresConfigValue - passwordChangedSinceInDays;

    if (
      isExternalUser(user) &&
      passwordValidDays &&
      passwordValidDays > 0 &&
      passwordValidDays <= 10
    ) {
      dispatch({
        type: 'setPasswordExpiryNotification',
        value: {
          title: CHANGE_PASSWORD,
          content: `${PASSWORD_EXPIRY_NOTIFICATION_TEXT} ${passwordValidDays} ${
            passwordValidDays === 1 ? DAY : DAYS
          }.`,
          onSubmit: () => navigate(getAccountPasswordUrl()),
          submitLabel: SUBMIT_LABEL,
          alertSeverity: 'warning',
        },
      });
    } else if (passwordValidDays === 0) {
      navigate(getAccountPasswordUrl());
    }
  }, [dispatch, navigate, user]);

  return null;
};

export default React.memo(PasswordExpiryNotification);
